export const NEXT_ROLE_SECTION_CONTENT_SPACING = 'large';
